import type { SerializedStyles, Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { breakpoint } from '@twistopayments/design-system/styles'

import type { TagVariant } from './tag'

export const container = (theme: Theme) => css`
  display: grid;
  position: relative;
  grid-auto-flow: column;
  grid-auto-columns: max-content;
  border-radius: ${theme.spacing[20]};
  column-gap: ${theme.spacing[4]};
  align-items: center;

  ${breakpoint.up('sm')} {
    column-gap: ${theme.spacing[8]};
  }
`

export const containerSize = (theme: Theme) => ({
  small: css`
    padding: ${theme.spacing[4]} ${theme.spacing[8]};

    ${breakpoint.up('sm')} {
      padding: ${theme.presentation.badge.smallDesktopPadding} ${theme.spacing[8]};
    }
  `,
  medium: css`
    padding: 6px ${theme.spacing[8]};

    ${breakpoint.up('sm')} {
      padding: ${theme.spacing[8]} ${theme.spacing[12]};
    }
  `,
})

export const background: Record<TagVariant, (theme: Theme) => SerializedStyles> = {
  success: (theme) => css`
    background-color: ${theme.palette.success.lowContrast};
  `,
  warning: (theme) => css`
    background-color: ${theme.palette.warning.lowContrast};
  `,
  error: (theme) => css`
    background-color: ${theme.palette.error.lowContrast};
  `,
  highlight: (theme) => css`
    background-color: ${theme.palette.secondary.mediumContrast};
  `,
  default: (theme) => css`
    background-color: ${theme.palette.tertiary.lowContrast};
  `,
}

export const fitContent = css`
  width: max-content;
  max-width: 100%;
`
